import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Switch } from "./ui/switch";
import { useConsent } from "../lib/consent";

const CATEGORIES = [
  { key: "essential", label: "Essential Cookies", locked: true,
    desc: "Required for core functionality, authentication and security. These are always on." },
  { key: "analytics", label: "Analytics Cookies",
    desc: "Help us understand how the website is used so we can improve its performance." },
  { key: "marketing", label: "Marketing Cookies",
    desc: "Used for advertising and marketing tracking." },
];

export default function CookiePreferences() {
  const { prefsOpen, closePreferences, categories, savePreferences } = useConsent();
  const [draft, setDraft] = useState({ analytics: false, marketing: false });

  // Re-seed from saved choices whenever the modal opens; optional categories default to off.
  useEffect(() => {
    if (prefsOpen) setDraft({ analytics: categories.analytics, marketing: categories.marketing });
  }, [prefsOpen, categories]);

  return (
    <Dialog open={prefsOpen} onOpenChange={(o) => { if (!o) closePreferences(); }}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto rounded-xl  bg-white text-black" data-testid="cookie-prefs-modal">
        <DialogHeader>
          <DialogTitle className="text-xl">Cookie preferences</DialogTitle>
          <DialogDescription>
            Choose which cookies you allow. You can change this at any time from the footer.{" "}
            <Link to="/privacy" onClick={closePreferences} className="underline hover:text-black">Privacy Policy</Link>
          </DialogDescription>
        </DialogHeader>
        <ul className="divide-y divide-black/10 border-y border-black/10">
          {CATEGORIES.map((c) => {
            const id = `cookie-${c.key}`;
            return (
              <li key={c.key} className="flex items-start justify-between gap-4 py-4">
                <div>
                  <label htmlFor={id} className="font-medium text-sm">{c.label}</label>
                  <p id={`${id}-desc`} className="text-sm text-black/60 mt-1">{c.desc}</p>
                </div>
                <Switch
                  id={id}
                  aria-describedby={`${id}-desc`}
                  checked={c.locked ? true : draft[c.key]}
                  disabled={c.locked}
                  onCheckedChange={(v) => setDraft((d) => ({ ...d, [c.key]: v }))}
                  className="mt-1 data-[state=checked]:bg-black"
                  data-testid={id}
                />
              </li>
            );
          })}
        </ul>
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
          <button type="button" className="btn-outline" onClick={closePreferences} data-testid="cookie-cancel">Cancel</button>
          <button type="button" className="btn-filled" onClick={() => savePreferences(draft)} data-testid="cookie-save">Save Preferences</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
